var render = function render(){var _vm=this,_c=_vm._self._c;return _c('object',{staticClass:"logo",attrs:{"type":"image/svg+xml","data":_vm.srcOriginal}})
}
var staticRenderFns = []

export { render, staticRenderFns }